export default "__VITE_ASSET__DqGKDws9__"